import { Button } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfoIcon from '@material-ui/icons/Info';
import SaveIcon from '@material-ui/icons/Save';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import React from 'react';
import formatNum from '../../../../utils/helpers';
import { Box } from '../../../UI';

export default function Pricing({ data, handleVariable }) {
	const {
		purchasePrice,
		transationCost,
		totalCost,
		TCperPP,
		grossCapRate,
		netCapRate,
		grossPricePerSqFt,
		netPricePerSqFt,
		grossPurchaseMulti,
		netPurchaseMulti,
	} = data;
	return (
		<ExpansionPanel style={{ background: '#eee' }}>
			<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
				<Typography variant="h6">
					<strong>Pricing</strong>
					<Tooltip title="Pricing input to be inserted by the user" aria-label="info">
						<IconButton color="inherit" aria-label="menu">
							<InfoIcon style={{ fontSize: '16px' }} color="primary" />
						</IconButton>
					</Tooltip>
				</Typography>
			</ExpansionPanelSummary>
			<ExpansionPanelDetails>
				<Box display="flex" flexDirection="column" width="100%">
					<TableContainer style={{ height: '431px' }}>
						<Table aria-label="simple table" style={{ marginBottom: '1rem' }}>
							<TableBody>
								<TableRow>
									<TableCell align="left">
										<strong>Purchase Price</strong>
									</TableCell>
									<TableCell align="right">
										<CurrencyTextField
											variant="standard"
											value={purchasePrice}
											currencySymbol="£"
											outputFormat="number"
											onChange={(event, value) => handleVariable(value, 'purchasePrice')}
										/>
										<IconButton color="inherit" aria-label="menu" disabled>
											<EditIcon style={{ fontSize: '16px' }} color="primary" />
										</IconButton>
									</TableCell>
									<TableCell />
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Transaction Costs</strong>
									</TableCell>
									<TableCell align="right">
										<CurrencyTextField
											variant="standard"
											value={transationCost}
											currencySymbol="£"
											outputFormat="number"
											onChange={(event, value) => handleVariable(value, 'transationCost')}
										/>
										<IconButton color="inherit" aria-label="menu" disabled>
											<EditIcon style={{ fontSize: '16px' }} color="primary" />
										</IconButton>
									</TableCell>
									<TableCell>{TCperPP}%</TableCell>
								</TableRow>
							</TableBody>
						</Table>
						<Table aria-label="simple table">
							<TableHead>
								<TableRow>
									<TableCell />
									<TableCell align="left">
										<strong>Gross</strong>
									</TableCell>
									<TableCell align="left">
										<strong>Net</strong>
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								<TableRow>
									<TableCell align="left">
										<strong>Cap Rate</strong>
									</TableCell>
									<TableCell align="right">{grossCapRate}%</TableCell>
									<TableCell align="right">{netCapRate}%</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Price per sq ft</strong>
									</TableCell>
									<TableCell align="right">£{formatNum(grossPricePerSqFt)}</TableCell>
									<TableCell align="right">£{formatNum(netPricePerSqFt)}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Purchase Multiple</strong>
									</TableCell>
									<TableCell align="right">{grossPurchaseMulti}</TableCell>
									<TableCell align="right">{netPurchaseMulti}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Total Cost</strong>
									</TableCell>
									<TableCell align="right">
										<strong>£{formatNum(totalCost)}</strong>
									</TableCell>
									<TableCell />
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
					<Box display="flex" justifyContent="flex-end" mt="1rem">
						<Button variant="contained" color="primary" startIcon={<SaveIcon />}>
							Save changes
						</Button>
					</Box>
				</Box>
			</ExpansionPanelDetails>
		</ExpansionPanel>
	);
}
